module.exports = __webpack_public_path__ + "img/pictoPeople2.98b15c43.svg";